'use client';

import { useTranslations } from 'next-intl';

export interface StoreBadgesProps {
  size?: 'sm' | 'md';
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const STORE_LINKS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.cinehubapp',
  appStore:
    'https://apps.apple.com/us/app/trakio-track-shows-movies/id6749806745'
};

function StoreBadges({
  size = 'md',
  orientation = 'vertical',
  className = ''
}: StoreBadgesProps) {
  const t = useTranslations();
  const imageWidth = size === 'sm' ? 'w-32' : 'w-40';
  const wrapperDirection =
    orientation === 'horizontal'
      ? 'flex-row flex-wrap items-center'
      : 'flex-col items-start';

  return (
    <div className={`flex ${wrapperDirection} gap-2 ${className}`}>
      <a
        href={STORE_LINKS.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-red-600/60 focus:ring-offset-2 focus:ring-offset-black"
      >
        <img
          src="/assets/app/googleplay-badge.png"
          alt={t('common.store_badges.google_play_alt')}
          className={`${imageWidth} h-auto`}
          loading="lazy"
        />
      </a>
      <a
        href={STORE_LINKS.appStore}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-red-600/60 focus:ring-offset-2 focus:ring-offset-black"
      >
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt={t('common.store_badges.app_store_alt')}
          className={`${imageWidth} h-auto`}
          loading="lazy"
        />
      </a>
    </div>
  );
}

export default StoreBadges;
